<template>
  <div class="modal-body-list-box">
    <div class="search-box-in-title">
      <h2>{{ $t('operation_image') }} {{ $t('list') }}</h2>
      <div style="display: flex; align-items: center; gap: 20px;">
        <h3 style="margin: 0;">{{ image_list.length }} / 9</h3>
        <label for="file">
          <div class="action-button" style="display: flex; align-items: center; cursor: pointer; height: 50px; padding: 10px; border-radius: 8px;" :style="getIsMobile() ? { fontSize: '10px' } : {}">{{ $t('upload_image') }}</div>
        </label>
        <input type="file" name="file" id="file" @change="uploadImage" accept="image/*" style="display: none;">
      </div>
    </div>
  
    <div class="image-grid" :style="getIsMobile() ? { padding: '10px 10px' } : {}">
      <div v-for="image in image_list" :key="image.id" class="image-item" @click="openImage(image)">
        <img :src="imageUrl() + image.path" :alt="'Uploaded at ' + image.uploadedAt" />
        <p class="timestamp">{{ image.originalname }}</p>
      </div>
    </div>

    <!-- 확대된 이미지 모달 -->
    <div v-if="showSmallModal" class="image-modal" @click.stop="closeImage">
      <img
        ref="imageElement"
        :src="imageUrl() + selectedImage?.path"
        :alt="`Image ${selectedImage?.id}`"
        class="zoomable-image"
        :style="{ transform: `scale(${zoomLevel}) translate(${offsetX}px, ${offsetY}px)` }"
        @mousedown="startDrag"
        @mousemove="dragImage"
        @mouseup="stopDrag"
        @mouseleave="stopDrag"
        @wheel="handleWheel"
        @click.stop="toggleZoom"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { imageUrl, GET_SERVER_REQUEST, SERVER_REQUEST } from '../utils/ServerConnect';
import { showNotification } from '@/utils/Notification';
import { loadingStore } from '@/utils/LoadingStore';
import { getIsMobile } from '@/utils/GlobalUtility';
import { showSmallModal } from '@/utils/ModalUtility';

const image_list = ref([]);

// 모달 상태 관리
const selectedImage = ref(null);

onMounted(async () => {
  searchOperation();
  loadingStore.hideLoading();
});
  
// 이미지 조회
const searchOperation = async () => {
  loadingStore.showLoading();
  image_list.value = await GET_SERVER_REQUEST('operation');
  loadingStore.hideLoading();
};

const uploadImage = async (event) => {
  loadingStore.showLoading();

  const file = event.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append("image", file);

  try {
    await SERVER_REQUEST('operation', 'POST', formData, false, null);
    loadingStore.hideLoading();
    searchOperation();
  } catch (error) {
    console.error("Error uploading image:", error);
    showNotification('Failed to upload image.', 'error', 'top-center');
  }

  event.target.value = null;
};

// 이미지 크게보기 열기
const openImage = (image) => {
  selectedImage.value = image;
  showSmallModal.value = true;
}
// 이미지 크게보기 닫기
const closeImage = () => {
  showSmallModal.value = false;
  selectedImage.value = null;
}

const zoomLevel = ref(1);
const dragging = ref(false);
const startX = ref(0);
const startY = ref(0);
const offsetX = ref(0);
const offsetY = ref(0);

const toggleZoom = () => {
  zoomLevel.value = zoomLevel.value === 1 ? 2 : 1;
  if (zoomLevel.value === 1) {
    offsetX.value = 0;
    offsetY.value = 0;
  }
};
const handleWheel = (event) => {
  event.preventDefault(); // 기본 스크롤 방지
  const zoomSpeed = 0.1;
  const newZoom = zoomLevel.value + (event.deltaY > 0 ? -zoomSpeed : zoomSpeed);
  zoomLevel.value = Math.max(1, Math.min(3, newZoom)); // 최소 1배, 최대 3배
};
const startDrag = (event) => {
  if (zoomLevel.value > 1) {
    dragging.value = true;
    startX.value = event.clientX - offsetX.value;
    startY.value = event.clientY - offsetY.value;
  }
};
const dragImage = (event) => {
  if (!dragging.value) return;
  offsetX.value = event.clientX - startX.value;
  offsetY.value = event.clientY - startY.value;
};
const stopDrag = () => {
  dragging.value = false;
};
</script>